import { Link } from 'react-router-dom';

import styles from '../../../../styles/Admin.module.scss';

function Item({ _id, enabled, credits, price, description, tokenType, showTokenType, archived, onArchive, onToggleEnabled, loading, enableLoading }) {
	const label = description?.trim()
		? description
		: `${credits} Token${credits === 1 ? '' : 's'}`;
	const tokenTypeLabel = tokenType === 'open_gym' ? 'Open Gym' : tokenType === 'class' ? 'Class' : 'General';
	const purchaseType = credits > 0 ? 'One-off + Recurring' : 'One-off only';
	const statusLabel = enabled ? 'Enabled' : 'Disabled';

	return (
		<tr className={!enabled ? styles.disabledRow : ''}>
			<td>
				<Link to={_id} className={styles.tableLink}>
					{label}
				</Link>
			</td>
			<td>£{(price / 100).toFixed(2)}</td>
			<td>{credits}{showTokenType ? ` (${tokenTypeLabel})` : ''}</td>
			<td>{purchaseType}</td>
			<td>{statusLabel}</td>
			<td className={styles.tableActions}>
				{!archived && (
					<button
						type="button"
						className={enabled ? "btn btnEmpty" : "btn btnPrimary"}
						onClick={() => onToggleEnabled(_id, !enabled)}
						disabled={enableLoading}
					>
						{enableLoading ? 'Updating...' : enabled ? 'Disable' : 'Enable'}
					</button>
				)}
				<button
					type="button"
					className={archived ? "btn btnPrimary" : "btn btnDanger"}
					onClick={() => onArchive(_id, !archived)}
					disabled={loading}
				>
					{loading ? 'Updating...' : archived ? 'Restore' : 'Deactivate'}
				</button>
			</td>
		</tr>
	)
}

export default Item;
